import { ReactElement } from "react";
import { IMeteredAddOnUsage } from "../../types";
import { UsageListing } from "./UsageListing";

interface IFreeAddOnUsageProps {
  dataTestId: string;
  /** what is metered, as the listing names it: "Ingested events" */
  unitLabel: string;
  usage: IMeteredAddOnUsage;
}

/** a grant that never bills: no rate to quote, no cost, no ceiling to draw */
export function FreeAddOnUsage({
  dataTestId,
  unitLabel,
  usage: { usage },
}: IFreeAddOnUsageProps): ReactElement {
  return (
    <UsageListing
      dataTestId={dataTestId}
      periodLabel="Current period"
      rowLabel={unitLabel}
      value={usage}
    />
  );
}
